// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { CaratRightIcon } from '@aurora/ui/aurora-design-system/src/icons/CaratRightIcon';
import { DownloadSaveIcon } from '@aurora/ui/aurora-design-system/src/icons/DownloadSaveIcon';
import landingTruckImage from '../static/aurora_qr_landing_truck.webp';
import brandAuroraLogo from '../static/brand_aurora_logo.svg';
var FIRST_RESPONDER_PDF_URL = 'https://downloads.ctfassets.net/9i0s3p5vkth9/2vvVrRM4qdKmi9IZ1LgqQ/b9336ee919c3a67c14abf1e96f9f2b92/-Final-_Aurora_First_Responders_Guide_-_May_2026.pdf';
function ListItem(param) {
    var title = param.title, description = param.description, icon = param.icon, href = param.href;
    return /*#__PURE__*/ React.createElement(Box, {
        component: "a",
        href: href,
        sx: {
            display: 'flex',
            alignItems: 'center',
            pl: 5,
            border: 1,
            borderColor: 'divider',
            borderRadius: 2,
            textDecoration: 'none',
            color: 'inherit',
            '&:focus-visible': {
                outline: '2px solid',
                outlineColor: 'info.main'
            }
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            flex: 1,
            minWidth: 0,
            py: 5
        },
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        color: "text.primary"
    }, title), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "text.secondary"
    }, description)), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            p: 5
        }
    }, icon));
}
export function LandingPage(param) {
    var vid = param.vid;
    var vidDisplay = vid || 'unknown';
    return /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            alignItems: 'center',
            minHeight: '100vh',
            bgcolor: 'common.white',
            maxWidth: 480,
            mx: 'auto'
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            alignItems: 'center',
            pt: 12,
            px: 5
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "img",
        src: brandAuroraLogo,
        alt: "Aurora",
        sx: {
            height: 20
        }
    }), /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        sx: {
            alignItems: 'center',
            maxWidth: 211,
            mt: 8
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "img",
        src: landingTruckImage,
        alt: "Aurora self-driving truck",
        sx: {
            width: 102,
            height: 102,
            objectFit: 'cover',
            flexShrink: 0
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "text.primary",
        align: "center"
    }, "You scanned truck ", vidDisplay)), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "text.primary",
        align: "center",
        sx: {
            mt: 7
        }
    }, "Is this an emergency?", ' ', /*#__PURE__*/ React.createElement(Typography, {
        component: "a",
        href: "tel:911",
        variant: "body1",
        sx: {
            color: 'inherit',
            textDecoration: 'none',
            '&:focus-visible': {
                outline: '2px solid',
                outlineColor: 'info.main',
                borderRadius: 1
            }
        }
    }, "Dial 9-1-1")), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        color: "text.primary",
        align: "center",
        sx: {
            mt: 8
        }
    }, "How can Aurora help you?")), /*#__PURE__*/ React.createElement(Stack, {
        spacing: 4,
        sx: {
            width: '100%',
            mt: 8,
            px: 4
        }
    }, /*#__PURE__*/ React.createElement(ListItem, {
        title: "General public",
        description: "Visit the Aurora website to learn more about our self-driving trucks",
        icon: /*#__PURE__*/ React.createElement(CaratRightIcon, null),
        href: "https://aurora.tech"
    }), /*#__PURE__*/ React.createElement(ListItem, {
        title: "First responder",
        description: "Download our first responders guide to walk through interacting with our trucks",
        icon: /*#__PURE__*/ React.createElement(DownloadSaveIcon, null),
        href: FIRST_RESPONDER_PDF_URL
    })));
}

//# sourceMappingURL=LandingPage.js.map